import { useCreatePortfolioSelectors } from 'datasource/CreatePortfolio';
import AgentInformationBase from 'pages/ClientOverview/pages/Portfolios/components/AgentInformation';
import React from 'react';
import { useParams } from 'react-router-dom';

import Preloader from 'components/Preloader';
import FeesOverviewBase from 'pages/ClientOverview/pages/Portfolios/components/FeesOverview';
import { useCustodyFee } from 'widgets/FeesOverview/hooks/useCustodyFee';
import { useAgentInformation } from './hooks/useAgentInformation';
import '../PersonalDetails/PersonalDetails.css';

const AgentInformation = () => {
    const {
        currentInvestmentDescriptionSelector,
        is3aPremiumProductGroupSelector,
    } = useCreatePortfolioSelectors();
    const zurichEmployee = currentInvestmentDescriptionSelector?.personalDetails?.zurichEmployee;
    const { dfsClientId } = useParams();

    const {
        feeData, onSave: saveFeeData, defaultCustodyFee, defaultAssetFee, saveFeeLocally, defaultEntryFee, defaultAdministrationFee,
    } = useCustodyFee({
        dfsClientId, isZivAzp: false, isZic: false, isAzp: false,
    });

    const {
        t,
        isAdvisorCanBeSelected,
        isManualPBRestricted,
        formatPhoneNumber,
        productDesc,
        issueCommissionSelected,
        issueCommissionChange,
        issueCommissionOptions,
        pbSelected,
        pbSelectOptions,
        fullPbNumber,
        pbChange,
        isPBTextFieldAvailable,
        advisorData,
        newPBValue,
        validation,
        onChangeNewPBNumber,
        changeVSTNumber,
        vstNumber,
        generalAgencies,
        selectedGeneralAgency,
        setSelectedGeneralAgency,
        agentsList,
        selectedAgent,
        setSelectedAgent,
        handleSearchAgents,
        searchAgentsInProgress,
        isPreloadInProgress,
    } = useAgentInformation({ dfsClientId, saveFeeData });

    // Handlers/Callbacks

    return (

        <>
            {is3aPremiumProductGroupSelector && (
                <FeesOverviewBase
                    t={t}
                    productDesc={productDesc}
                    defaultCustodyFee={defaultCustodyFee}
                    feeData={feeData}
                    defaultAssetFee={defaultAssetFee}
                    isZivAzp={false}
                    isZic={false}
                    saveFeeLocally={saveFeeLocally}
                    defaultEntryFee={defaultEntryFee}
                    is3ap={is3aPremiumProductGroupSelector}
                    defaultAdministrationFee={defaultAdministrationFee}
                />
            )}
            <Preloader isLoading={isPreloadInProgress}>
                <AgentInformationBase
                    {...{
                        t,
                        isManualPBRestricted,
                        isAdvisorCanBeSelected,
                        validation,
                        formatPhoneNumber,
                        productDesc,
                        issueCommissionSelected,
                        issueCommissionChange,
                        issueCommissionOptions,
                        pbSelected,
                        pbSelectOptions,
                        fullPbNumber,
                        pbChange,
                        isPBTextFieldAvailable,
                        advisorData,
                        newPBValue,
                        onChangeNewPBNumber,
                        changeVSTNumber,
                        vstNumber,
                        generalAgencies,
                        selectedGeneralAgency,
                        setSelectedGeneralAgency,
                        agentsList,
                        selectedAgent,
                        setSelectedAgent,
                        handleSearchAgents,
                        searchAgentsInProgress,
                        zurichEmployee,
                        is3aPremiumProductGroupSelector,
                        isZic: false,
                        isPk: false,
                    }}
                />
            </Preloader>
        </>
    );
};

export default AgentInformation;
